// Traduções deste bloco — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'dashboard.outrosServicos.titulo': 'Resumo de Outros Serviços',
    'dashboard.outrosServicos.dica': 'Viagens e diárias ativas no dia, por Cliente HUB e Serviço HUB',
    'dashboard.outrosServicos.vazio': 'Nenhuma viagem de Outros Serviços ativa neste dia.',
    'dashboard.outrosServicos.erro': 'Não foi possível carregar o resumo de Outros Serviços.',
    'dashboard.outrosServicos.semVinculo': 'Cliente não vinculado',
    'dashboard.outrosServicos.naoClassificado': 'Serviço não classificado',
    'dashboard.outrosServicos.diaria': 'Diária',
    'dashboard.outrosServicos.semClienteHub': 'Sem Cliente HUB',
    'dashboard.outrosServicos.semClienteHubDica': 'O cliente do Protheus ainda não está vinculado a um Cliente HUB. O vínculo é feito em Cadastros, na aba Clientes HUB.',
    'dashboard.outrosServicos.abrir': 'Abrir {{servico}} de {{cliente}} em Outros Serviços Transporte',
  },
  en: {
    'dashboard.outrosServicos.titulo': 'Other Services summary',
    'dashboard.outrosServicos.dica': 'Trips and daily hires active on the day, by HUB customer and HUB service',
    'dashboard.outrosServicos.vazio': 'No Other Services trip active on this day.',
    'dashboard.outrosServicos.erro': 'Could not load the Other Services summary.',
    'dashboard.outrosServicos.semVinculo': 'Customer not linked',
    'dashboard.outrosServicos.naoClassificado': 'Service not classified',
    'dashboard.outrosServicos.diaria': 'Daily hire',
    'dashboard.outrosServicos.semClienteHub': 'No HUB customer',
    'dashboard.outrosServicos.semClienteHubDica': 'The Protheus customer is not linked to a HUB customer yet. Link it in Records, HUB Customers tab.',
    'dashboard.outrosServicos.abrir': 'Open {{servico}} for {{cliente}} in Other Transport Services',
  },
  es: {
    'dashboard.outrosServicos.titulo': 'Resumen de Otros Servicios',
    'dashboard.outrosServicos.dica': 'Viajes y diarias activos en el día, por Cliente HUB y Servicio HUB',
    'dashboard.outrosServicos.vazio': 'Ningún viaje de Otros Servicios activo en este día.',
    'dashboard.outrosServicos.erro': 'No fue posible cargar el resumen de Otros Servicios.',
    'dashboard.outrosServicos.semVinculo': 'Cliente no vinculado',
    'dashboard.outrosServicos.naoClassificado': 'Servicio no clasificado',
    'dashboard.outrosServicos.diaria': 'Diaria',
    'dashboard.outrosServicos.semClienteHub': 'Sin Cliente HUB',
    'dashboard.outrosServicos.semClienteHubDica': 'El cliente de Protheus aún no está vinculado a un Cliente HUB. El vínculo se hace en Registros, pestaña Clientes HUB.',
    'dashboard.outrosServicos.abrir': 'Abrir {{servico}} de {{cliente}} en Otros Servicios de Transporte',
  },
}
